<div class="main1">
    <header>
        <div class="header" style="display:block">
            {{heading}}
        </div>
    </header>
    <app-audio [playAudio]="playAudio"></app-audio>
    <!-- <app-notification-message [errorMessage]="errorMessage" class="notf"></app-notification-message> -->
    <div fxLayout="row wrap" fxLayoutGap="5px 10px grid" style="padding: 15px;">
        <div fxFlex="100%">
            <app-notification-message [errorMessage]="errorMessage"></app-notification-message>
        </div>
        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px; width: 50px;"> <label for="route">Route</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.routeCode" readonly>
                </div>
            </div>
        </div>
        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">Date</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.connectionDate" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">Supplier</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.supplierCode" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">Order</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.orderNumber" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">P-D</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.pd" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">Created</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.createdDate+' '+showdata.createdTime" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin:20px;width: 50px;"> <label for="route">User</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <input type="text" [value]="showdata.createdByUserId" readonly>
                </div>
            </div>
        </div>

        <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" fxFlex.md="50%" fxLayout="row">
            <div style="margin: 15px 5px 15px 15px; width: 60px;"> <label for="route">Type - Category - Detail</label></div>
            <div style="margin:20px 10px;">
                <div>
                    <select [(ngModel)]="categorytype" [ngModelOptions]="{standalone: true}" class="category four">
                        <option *ngFor="let category of typedata" [value]="category.issueid">
                            {{category.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

    </div>

    <div class="footerp cfooter">
        <label class="cancel" style="position: relative; right: 27px;" (click)="onNoClick()"> CANCEL
        </label>
        <button mat-raised-button class="submit" type="submit" style="display: inline;margin-right: 4%;"
            (click)="saveClick()">SAVE</button>
    </div>
</div>